export default {
	'shared.all': 'All',
	'shared.minutes': 'minutes',
	'shared.submit': 'Submit',
	'shared.closeDrawer': 'Close drawer',
};
